/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum UndoTypes {
	test = 'test',
	test2 = 'test2',
	ticketMove = 'ticketMove',
	ticketDelete = 'ticketDelete',
	ticketEdit = 'ticketEdit',
	ticketDuplicate = 'ticketDuplicate',
	ticketPaste = 'ticketPaste', // clipboard
	promisePeriodChange = 'promisePeriodChange',
}

export enum UndoTitles {
	ticketMove = 'Ticket Move',
	ticketDelete = 'Ticket Delete',
	ticketEdit = 'Ticket Edit',
	multiTicketEdit = 'Multi Ticket Edit',
	ticketDuplicate = 'Ticket Duplicate',
	ticketPaste = 'Ticket Paste', // clipboard
	promisePeriodChange = 'Promise Period Change',
}
